import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { BadgeSelectorComponent } from 'src/app/reusables/badge-selector/badge-selector.component';
import { cloneDeep } from 'lodash';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-configure-rewards-connect3',
  templateUrl: './configure-rewards-connect3.component.html',
  styleUrls: ['./configure-rewards-connect3.component.scss']
})
export class ConfigureRewardsConnect3Component implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  rewards: any = null;
  rewardType: any = null;
  selectedReward: any = null;
  showBadgeSelector: boolean = false;
  showRemove : { [key: string]: boolean } = { ThreeInRow: false, Blackout: false };
  consideredComplete: boolean = false;
  oldBadgeSelected: number = 0;

  radioValues = {
    rewardType: {
      threeInRow: 0,
      blackout: 1,
      both: 2
    }
  };
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private modalService: NgbModal,
    public cvConfigurationService: CvConfigurationService
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    this.rewardType = (this.gs.modified.item.underlyingRule.GameType == 6) ? this.radioValues.rewardType.threeInRow : this.radioValues.rewardType.blackout;
    this.gs.modified.item.Connect3Rewards = this.gs.modified.item.Connect3Rewards || this._Connect3RewardsTemplate();
    this.rewards = this.gs.modified.item.Connect3Rewards;
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngDoCheck(): void {
      if (this.rewards != null) {
          if ((this.rewards.ThreeInRow?.badge > 0 && this.rewards.ThreeInRow?.badge != this.oldBadgeSelected) || (this.rewards.Blackout?.badge > 0 && this.rewards.Blackout?.badge != this.oldBadgeSelected)) {
              this.oldBadgeSelected = this.rewards.ThreeInRow?.badge > 0 ? this.rewards.ThreeInRow.badge : this.rewards.Blackout.badge;
              this.checkForComponentCompletion();
          }
    }
  }

  c3rewardgroup(): any {
    return { coins: 0, xp: 0, badge: 0 }
  }

  _Connect3RewardsTemplate(): any {
    let ThreeInRow = this.c3rewardgroup();
    let Blackout = this.c3rewardgroup();

    return {ThreeInRow, Blackout};
  }

  popBadgeSelector (selectedReward: any): void {
    this.showBadgeSelector = true;
    this.selectedReward = selectedReward;

    const modalRef = this.modalService.open(BadgeSelectorComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    //Sending input value
    modalRef.componentInstance.header = this.gamesService.getLocalizedMessage("Select_Badge", "Select your badge");
    modalRef.componentInstance.showWhen = this.showBadgeSelector;
    modalRef.componentInstance.showCustomBadge = !this.isCxone;

    //Catching event answer
    modalRef.componentInstance.onBadgeSelected.subscribe(result => {
      this.selectedReward.badge = result;
      modalRef.close();
    });
  }

  getPopoverTemplate(badgeID: number): string {
    return "<div class='glaeBadgePopover'><img src=\"../Admin/ImageResizer.aspx?imgid=" + badgeID + "&w=128&h=128\" /></div>"
  }

  checkForComponentCompletion (): void {
    if (!this.consideredComplete) {
      if (this.rewards.ThreeInRow?.coins > 0 || this.rewards.ThreeInRow?.xp > 0 || this.rewards.ThreeInRow?.badge > 0 ||
          this.rewards.Blackout?.coins > 0 || this.rewards.Blackout?.xp > 0 || this.rewards.Blackout?.badge > 0) {
        //Fire one time event to unlock the next component
        var eventArgs = {
            currentStep: this.step - 1,
            unlocks: this.componentOptions.unlocks
        };

        this.componentComplete.emit(eventArgs);
        this.consideredComplete = true;
      }
    }
  }

  removeBadge(rewardObject): void {
    rewardObject.badge = 0;
  }
}
